import { createFileRoute, redirect } from "@tanstack/react-router";
import AppCard from "@components/AppCard.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";
import { getHasHrdAccess } from "@/auth/hasHrdAccess.tsx";
import HrdLaboratoriesDataGrid from "@components/hrd/laboratories/HrdLaboratoriesDataGrid.tsx";

export const Route = createFileRoute("/_dashboard/hrd/laboratories")({
  beforeLoad: (args) => {
    const { context } = args;
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
    const hasHrdAccess = getHasHrdAccess(
      context.session!.user!.hrdAccessStatus
    );

    // Check HRD access for non-admins only
    if (!context.session?.user?.isAdmin && !hasHrdAccess) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }

    return { session: context.session! };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AppCard title={"HRD Collect - Laboratoires"}>
      <HrdLaboratoriesDataGrid />
    </AppCard>
  );
}
